export default __webpack_public_path__ + "static/media/sp-sbo-boy.f0b0222c.webp";